import type { ReactNode } from "react"
import { Text } from "@smooth/design-system-components"
import type { ScenarioMessage } from "../types"

type BubbleProps = {
  direction: ScenarioMessage["direction"]
  meta: string
  children: ReactNode
  /** 未送信の AIドラフト。点線の枠で送信済みの発言と見分ける */
  draft?: boolean
}

/** 会話の1発言。お客様は左、当社は右に寄せる */
export function Bubble({ direction, meta, children, draft = false }: BubbleProps) {
  const outbound = direction === "outbound"
  return (
    <div className={`flex max-w-[85%] flex-col gap-1 ${outbound ? "self-end items-end" : ""}`}>
      <Text as="span" size="sm">
        {meta}
      </Text>
      <div
        className={[
          "whitespace-pre-wrap rounded-md px-3 py-2 [overflow-wrap:anywhere]",
          outbound ? "bg-bg-info" : "bg-bg-muted",
          draft ? "border border-dashed border-action-primary leading-loose" : "",
        ].join(" ")}
      >
        <Text>{children}</Text>
      </div>
    </div>
  )
}
